import React, { Component } from 'react';
import API from '../api';

const formatDate = (dateStr, opts) => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-US', opts || {
    weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'
  });
};

const formatTime = (dateStr) => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleTimeString('en-US', {
    hour: 'numeric', minute: '2-digit'
  });
};

const GroupDetail = ({ data }) => (
  <div className="pco-detail-content">
    {data.image_url && (
      <img className="pco-detail-hero" src={data.image_url} alt={data.name} />
    )}
    <h1>{data.name}</h1>
    <div className="pco-detail-meta">
      {data.group_type && <span>{data.group_type}</span>}
      {data.schedule && <span>📅 {data.schedule}</span>}
      {data.location && <span>📍 {data.location}</span>}
    </div>
    {data.description && (
      <div className="pco-detail-body" dangerouslySetInnerHTML={{ __html: data.description }} />
    )}
    {data.enrollment_url && (
      <a className="pco-detail-btn" href={data.enrollment_url} target="_blank" rel="noopener">
        Join This Group
      </a>
    )}
  </div>
);

const EventDetail = ({ data }) => (
  <div className="pco-detail-content">
    {data.image_url && (
      <img className="pco-detail-hero" src={data.image_url} alt={data.name} />
    )}
    <h1>{data.name}</h1>
    <div className="pco-detail-meta">
      {data.starts_at && <span>📅 {formatDate(data.starts_at)}</span>}
      {data.starts_at && (
        <span>🕐 {formatTime(data.starts_at)}{data.ends_at ? ` – ${formatTime(data.ends_at)}` : ''}</span>
      )}
      {data.location && <span>📍 {data.location}</span>}
    </div>
    {data.description && (
      <div className="pco-detail-body" dangerouslySetInnerHTML={{ __html: data.description }} />
    )}
    {data.registration_url && (
      <a className="pco-detail-btn" href={data.registration_url} target="_blank" rel="noopener">
        Register
      </a>
    )}
  </div>
);

const MessageDetail = ({ data }) => (
  <div className="pco-detail-content">
    {data.image_url && (
      <img className="pco-detail-hero" src={data.image_url} alt={data.title} />
    )}
    <h1>{data.title}</h1>
    {data.series_title && <div className="pco-detail-series">{data.series_title}</div>}
    <div className="pco-detail-meta">
      {data.speaker && <span>🎤 {data.speaker}</span>}
      {data.published_at && <span>📅 {formatDate(data.published_at)}</span>}
    </div>
    {data.video_url && (
      <div className="pco-detail-player">
        <video controls preload="metadata" src={data.video_url} />
      </div>
    )}
    {!data.video_url && data.audio_url && (
      <div className="pco-detail-player">
        <audio controls preload="metadata" src={data.audio_url} />
      </div>
    )}
    {data.description && (
      <div className="pco-detail-body" dangerouslySetInnerHTML={{ __html: data.description }} />
    )}
  </div>
);

const DETAIL_COMPONENTS = {
  group: GroupDetail,
  event: EventDetail,
  message: MessageDetail,
};

class DetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = { data: null, loading: true, error: null };
    this._handleKeyDown = this._handleKeyDown.bind(this);
    this._handleBackdropClick = this._handleBackdropClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this._handleKeyDown);
    document.body.style.overflow = 'hidden';
    this.fetchDetail();
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this._handleKeyDown);
    document.body.style.overflow = '';
  }

  _handleKeyDown(e) {
    if (e.key === 'Escape') this.props.onClose();
  }

  _handleBackdropClick(e) {
    if (e.target === e.currentTarget) this.props.onClose();
  }

  fetchDetail() {
    const { itemType, itemId, siteUniqueName, host, protocol } = this.props;
    const p = protocol || 'https';
    const h = host || 'orbitalsites.com';

    API.getPcoDetail(p, h, siteUniqueName, itemType, itemId)
      .then(json => {
        if (json && json.data) {
          this.setState({ data: json.data, loading: false });
        } else {
          this.setState({ error: 'Not found', loading: false });
        }
      })
      .catch(() => {
        this.setState({ error: 'Failed to load details', loading: false });
      });
  }

  render() {
    const { itemType, onClose } = this.props;
    const { data, loading, error } = this.state;
    const DetailComponent = DETAIL_COMPONENTS[itemType];

    return (
      <div className="pco-modal-backdrop" onClick={this._handleBackdropClick}>
        <div className="pco-modal">
          <button className="pco-modal-close" onClick={onClose} aria-label="Close">✕</button>
          {loading && (
            <div className="pco-modal-loading"><p>Loading...</p></div>
          )}
          {error && (
            <div className="pco-modal-loading"><p>{error}</p></div>
          )}
          {!loading && !error && data && DetailComponent && (
            <DetailComponent data={data} />
          )}
        </div>
      </div>
    );
  }
}

export default DetailModal;
